import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import {
  currencyFormatter,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  toAbsoluteUrl
} from "../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";

export default function DonationTableList({
  entities = [],
  totalCount,
  listLoading,
  queryParams,
  setQueryParams,
  setSelectedDonation,
  donationResponse
}) {
  // Table columns
  const columns = [
    {
      dataField: "donation.donation_hid",
      text: "ID Donasi",
      sort: true
    },
    {
      dataField: "donation.trx_date",
      text: "Tanggal Donasi",
      sort: true
    },
    {
      dataField: "type",
      text: "Jenis Donasi",
      sort: true
    },
    {
      dataField: "program.name",
      text: "Program",
      sort: true
    },
    {
      dataField: "donation.donor.name",
      text: "Nama Donatur",
      sort: true
    },
    {
      dataField: "amount",
      headerClasses: "text-right",
      classes: "text-right",
      text: "Total",
      sort: true,
      formatter: cell => {
        return currencyFormatter(cell);
      }
    },
    {
      text: "Action",
      formatter: (_, row) => {
        return (
          <span>
            <a
              className="btn btn-icon btn-light btn-hover-info btn-sm mx-3"
              onClick={() => window.open(`/donasi/${row.donation.uuid}/detail`)}
            >
              <span className="svg-icon svg-icon-md svg-icon-info">
                <i
                  style={{ fontSize: "16px" }}
                  class="fas fa-eye align-self-center"
                ></i>
              </span>
            </a>
          </span>
        );
      }
    }
  ];

  // const selectRow = {
  //   mode: "checkbox",
  //   clickToSelect: true,
  //   onSelect: (row, isSelect, rowIndex, e) => {
  //     setSelectedDonation(prev => {
  //       const temp = [...prev];
  //       if (isSelect) {
  //         temp.push(row);
  //         return temp;
  //       } else {
  //         const newDonation = temp.filter(
  //           donation => donation.uuid !== row.uuid
  //         );
  //         return newDonation;
  //       }
  //     });
  //   },
  //   onSelectAll: (isSelect, rows, e) => {
  //     if (isSelect) {
  //       setSelectedDonation(rows);
  //     } else {
  //       setSelectedDonation([]);
  //     }
  //   }
  // };

  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "25", value: 25 },
    { text: "50", value: 50 }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                onTableChange={getHandlerTableChange(setQueryParams)}
                // selectRow={selectRow}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
